import agentConfigsMessages from '../../messages/en/agentConfigs.json';
import billingMessages from '../../messages/en/billing.json';
import apiErrorDetailsMessages from '../../messages/en/apiErrorDetails.json';
import apiErrorsMessages from '../../messages/en/apiErrors.json';
import authMessages from '../../messages/en/auth.json';
import authorBadgeMessages from '../../messages/en/authorBadge.json';
import cliMessages from '../../messages/en/cli.json';
import coActionsMessages from '../../messages/en/coActions.json';
import codeReviewsMessages from '../../messages/en/codeReviews.json';
import commonMessages from '../../messages/en/common.json';
import completionReportConnectModalMessages from '../../messages/en/completionReportConnectModal.json';
import completionReportsMessages from '../../messages/en/completionReports.json';
import componentsMessages from '../../messages/en/components.json';
import conventionsMessages from '../../messages/en/conventions.json';
import daemonTriggersMessages from '../../messages/en/daemonTriggers.json';
import dashboardMessages from '../../messages/en/dashboard.json';
import documentsMessages from '../../messages/en/documents.json';
import homeMessages from '../../messages/en/home.json';
import errorsMessages from '../../messages/en/errors.json';
import executionEnvironmentMessages from '../../messages/en/executionEnvironment.json';
import feedbackQuickViewMessages from '../../messages/en/feedbackQuickView.json';
import feedbacksMessages from '../../messages/en/feedbacks.json';
import invitationsMessages from '../../messages/en/invitations.json';
import goMessages from '../../messages/en/go.json';
import invitesMessages from '../../messages/en/invites.json';
import landingMessages from '../../messages/en/landing.json';
import memberRunnerModelsMessages from '../../messages/en/memberRunnerModels.json';
import mermaidCodeBlockMessages from '../../messages/en/mermaidCodeBlock.json';
import navMessages from '../../messages/en/nav.json';
import planAuthorBadgeMessages from '../../messages/en/planAuthorBadge.json';
import planConnectModalMessages from '../../messages/en/planConnectModal.json';
import plansMessages from '../../messages/en/plans.json';
import portalMessages from '../../messages/en/portal.json';
import postMortemConnectModalMessages from '../../messages/en/postMortemConnectModal.json';
import postMortemsMessages from '../../messages/en/postMortems.json';
import profileMessages from '../../messages/en/profile.json';
import publicHeaderMessages from '../../messages/en/publicHeader.json';
import projectsMessages from '../../messages/en/projects.json';
import skillsMessages from '../../messages/en/skills.json';
import sharedSkillsMessages from '../../messages/en/sharedSkills.json';
import systemMembersMessages from '../../messages/en/systemMembers.json';
import systemRunnerModelsMessages from '../../messages/en/systemRunnerModels.json';
import systemTeamsMessages from '../../messages/en/systemTeams.json';
import teamsMessages from '../../messages/en/teams.json';
import uiErrorsMessages from '../../messages/en/uiErrors.json';
import notificationsMessages from '../../messages/en/notifications.json';
import workspaceMessages from '../../messages/en/workspace.json';
import systemMonitoringMessages from '../../messages/en/systemMonitoring.json';
import systemSearchMessages from '../../messages/en/systemSearch.json';
import systemConfigMessages from '../../messages/en/systemConfig.json';

import koAgentConfigsMessages from '../../messages/ko/agentConfigs.json';
import koBillingMessages from '../../messages/ko/billing.json';
import koApiErrorDetailsMessages from '../../messages/ko/apiErrorDetails.json';
import koApiErrorsMessages from '../../messages/ko/apiErrors.json';
import koAuthMessages from '../../messages/ko/auth.json';
import koAuthorBadgeMessages from '../../messages/ko/authorBadge.json';
import koCliMessages from '../../messages/ko/cli.json';
import koCoActionsMessages from '../../messages/ko/coActions.json';
import koCodeReviewsMessages from '../../messages/ko/codeReviews.json';
import koCommonMessages from '../../messages/ko/common.json';
import koCompletionReportConnectModalMessages from '../../messages/ko/completionReportConnectModal.json';
import koCompletionReportsMessages from '../../messages/ko/completionReports.json';
import koComponentsMessages from '../../messages/ko/components.json';
import koConventionsMessages from '../../messages/ko/conventions.json';
import koDaemonTriggersMessages from '../../messages/ko/daemonTriggers.json';
import koDashboardMessages from '../../messages/ko/dashboard.json';
import koDocumentsMessages from '../../messages/ko/documents.json';
import koErrorsMessages from '../../messages/ko/errors.json';
import koExecutionEnvironmentMessages from '../../messages/ko/executionEnvironment.json';
import koFeedbackQuickViewMessages from '../../messages/ko/feedbackQuickView.json';
import koFeedbacksMessages from '../../messages/ko/feedbacks.json';
import koHomeMessages from '../../messages/ko/home.json';
import koInvitationsMessages from '../../messages/ko/invitations.json';
import koGoMessages from '../../messages/ko/go.json';
import koInvitesMessages from '../../messages/ko/invites.json';
import koLandingMessages from '../../messages/ko/landing.json';
import koMemberRunnerModelsMessages from '../../messages/ko/memberRunnerModels.json';
import koMermaidCodeBlockMessages from '../../messages/ko/mermaidCodeBlock.json';
import koNavMessages from '../../messages/ko/nav.json';
import koNotificationsMessages from '../../messages/ko/notifications.json';
import koPlanAuthorBadgeMessages from '../../messages/ko/planAuthorBadge.json';
import koPlanConnectModalMessages from '../../messages/ko/planConnectModal.json';
import koPlansMessages from '../../messages/ko/plans.json';
import koPortalMessages from '../../messages/ko/portal.json';
import koPostMortemConnectModalMessages from '../../messages/ko/postMortemConnectModal.json';
import koPostMortemsMessages from '../../messages/ko/postMortems.json';
import koProfileMessages from '../../messages/ko/profile.json';
import koProjectsMessages from '../../messages/ko/projects.json';
import koSkillsMessages from '../../messages/ko/skills.json';
import koSharedSkillsMessages from '../../messages/ko/sharedSkills.json';
import koPublicHeaderMessages from '../../messages/ko/publicHeader.json';
import koSystemMembersMessages from '../../messages/ko/systemMembers.json';
import koSystemRunnerModelsMessages from '../../messages/ko/systemRunnerModels.json';
import koSystemTeamsMessages from '../../messages/ko/systemTeams.json';
import koTeamsMessages from '../../messages/ko/teams.json';
import koUiErrorsMessages from '../../messages/ko/uiErrors.json';
import koWorkspaceMessages from '../../messages/ko/workspace.json';
import koSystemMonitoringMessages from '../../messages/ko/systemMonitoring.json';
import koSystemSearchMessages from '../../messages/ko/systemSearch.json';
import koSystemConfigMessages from '../../messages/ko/systemConfig.json';

import type { AppLocale } from '../lib/locale';

type JsonObject = Record<string, unknown>;

const messageSources: Array<{ name: string; messages: JsonObject }> = [
  { name: 'agentConfigs', messages: agentConfigsMessages as JsonObject },
  { name: 'billing', messages: billingMessages as JsonObject },
  { name: 'apiErrorDetails', messages: apiErrorDetailsMessages as JsonObject },
  { name: 'apiErrors', messages: apiErrorsMessages as JsonObject },
  { name: 'auth', messages: authMessages as JsonObject },
  { name: 'authorBadge', messages: authorBadgeMessages as JsonObject },
  { name: 'cli', messages: cliMessages as JsonObject },
  { name: 'coActions', messages: coActionsMessages as JsonObject },
  { name: 'codeReviews', messages: codeReviewsMessages as JsonObject },
  { name: 'common', messages: commonMessages as JsonObject },
  {
    name: 'completionReportConnectModal',
    messages: completionReportConnectModalMessages as JsonObject,
  },
  { name: 'completionReports', messages: completionReportsMessages as JsonObject },
  { name: 'components', messages: componentsMessages as JsonObject },
  { name: 'conventions', messages: conventionsMessages as JsonObject },
  { name: 'daemonTriggers', messages: daemonTriggersMessages as JsonObject },
  { name: 'dashboard', messages: dashboardMessages as JsonObject },
  { name: 'documents', messages: documentsMessages as JsonObject },
  { name: 'home', messages: homeMessages as JsonObject },
  { name: 'errors', messages: errorsMessages as JsonObject },
  { name: 'executionEnvironment', messages: executionEnvironmentMessages as JsonObject },
  { name: 'feedbackQuickView', messages: feedbackQuickViewMessages as JsonObject },
  { name: 'feedbacks', messages: feedbacksMessages as JsonObject },
  { name: 'invitations', messages: invitationsMessages as JsonObject },
  { name: 'go', messages: goMessages as JsonObject },
  { name: 'invites', messages: invitesMessages as JsonObject },
  { name: 'landing', messages: landingMessages as JsonObject },
  { name: 'memberRunnerModels', messages: memberRunnerModelsMessages as JsonObject },
  { name: 'mermaidCodeBlock', messages: mermaidCodeBlockMessages as JsonObject },
  { name: 'nav', messages: navMessages as JsonObject },
  { name: 'planAuthorBadge', messages: planAuthorBadgeMessages as JsonObject },
  { name: 'planConnectModal', messages: planConnectModalMessages as JsonObject },
  { name: 'plans', messages: plansMessages as JsonObject },
  { name: 'portal', messages: portalMessages as JsonObject },
  {
    name: 'postMortemConnectModal',
    messages: postMortemConnectModalMessages as JsonObject,
  },
  { name: 'postMortems', messages: postMortemsMessages as JsonObject },
  { name: 'profile', messages: profileMessages as JsonObject },
  { name: 'publicHeader', messages: publicHeaderMessages as JsonObject },
  { name: 'projects', messages: projectsMessages as JsonObject },
  { name: 'skills', messages: skillsMessages as JsonObject },
  { name: 'sharedSkills', messages: sharedSkillsMessages as JsonObject },
  { name: 'systemMembers', messages: systemMembersMessages as JsonObject },
  { name: 'systemRunnerModels', messages: systemRunnerModelsMessages as JsonObject },
  { name: 'systemTeams', messages: systemTeamsMessages as JsonObject },
  { name: 'teams', messages: teamsMessages as JsonObject },
  { name: 'notifications', messages: notificationsMessages as JsonObject },
  { name: 'uiErrors', messages: uiErrorsMessages as JsonObject },
  { name: 'workspace', messages: workspaceMessages as JsonObject },
  { name: 'systemMonitoring', messages: systemMonitoringMessages as JsonObject },
  { name: 'systemSearch', messages: systemSearchMessages as JsonObject },
  { name: 'systemConfig', messages: systemConfigMessages as JsonObject },
];

const koOverrideSources: Array<{ name: string; messages: JsonObject }> = [
  { name: 'agentConfigs', messages: koAgentConfigsMessages as JsonObject },
  { name: 'billing', messages: koBillingMessages as JsonObject },
  { name: 'apiErrorDetails', messages: koApiErrorDetailsMessages as JsonObject },
  { name: 'apiErrors', messages: koApiErrorsMessages as JsonObject },
  { name: 'auth', messages: koAuthMessages as JsonObject },
  { name: 'authorBadge', messages: koAuthorBadgeMessages as JsonObject },
  { name: 'cli', messages: koCliMessages as JsonObject },
  { name: 'coActions', messages: koCoActionsMessages as JsonObject },
  { name: 'codeReviews', messages: koCodeReviewsMessages as JsonObject },
  { name: 'common', messages: koCommonMessages as JsonObject },
  {
    name: 'completionReportConnectModal',
    messages: koCompletionReportConnectModalMessages as JsonObject,
  },
  { name: 'completionReports', messages: koCompletionReportsMessages as JsonObject },
  { name: 'components', messages: koComponentsMessages as JsonObject },
  { name: 'conventions', messages: koConventionsMessages as JsonObject },
  { name: 'daemonTriggers', messages: koDaemonTriggersMessages as JsonObject },
  { name: 'dashboard', messages: koDashboardMessages as JsonObject },
  { name: 'documents', messages: koDocumentsMessages as JsonObject },
  { name: 'errors', messages: koErrorsMessages as JsonObject },
  { name: 'executionEnvironment', messages: koExecutionEnvironmentMessages as JsonObject },
  { name: 'feedbackQuickView', messages: koFeedbackQuickViewMessages as JsonObject },
  { name: 'feedbacks', messages: koFeedbacksMessages as JsonObject },
  { name: 'home', messages: koHomeMessages as JsonObject },
  { name: 'invitations', messages: koInvitationsMessages as JsonObject },
  { name: 'go', messages: koGoMessages as JsonObject },
  { name: 'invites', messages: koInvitesMessages as JsonObject },
  { name: 'landing', messages: koLandingMessages as JsonObject },
  { name: 'memberRunnerModels', messages: koMemberRunnerModelsMessages as JsonObject },
  { name: 'mermaidCodeBlock', messages: koMermaidCodeBlockMessages as JsonObject },
  { name: 'nav', messages: koNavMessages as JsonObject },
  { name: 'notifications', messages: koNotificationsMessages as JsonObject },
  { name: 'planAuthorBadge', messages: koPlanAuthorBadgeMessages as JsonObject },
  { name: 'planConnectModal', messages: koPlanConnectModalMessages as JsonObject },
  { name: 'plans', messages: koPlansMessages as JsonObject },
  { name: 'portal', messages: koPortalMessages as JsonObject },
  {
    name: 'postMortemConnectModal',
    messages: koPostMortemConnectModalMessages as JsonObject,
  },
  { name: 'postMortems', messages: koPostMortemsMessages as JsonObject },
  { name: 'profile', messages: koProfileMessages as JsonObject },
  { name: 'projects', messages: koProjectsMessages as JsonObject },
  { name: 'publicHeader', messages: koPublicHeaderMessages as JsonObject },
  { name: 'skills', messages: koSkillsMessages as JsonObject },
  { name: 'sharedSkills', messages: koSharedSkillsMessages as JsonObject },
  { name: 'systemMembers', messages: koSystemMembersMessages as JsonObject },
  { name: 'systemRunnerModels', messages: koSystemRunnerModelsMessages as JsonObject },
  { name: 'systemTeams', messages: koSystemTeamsMessages as JsonObject },
  { name: 'teams', messages: koTeamsMessages as JsonObject },
  { name: 'uiErrors', messages: koUiErrorsMessages as JsonObject },
  { name: 'workspace', messages: koWorkspaceMessages as JsonObject },
  { name: 'systemMonitoring', messages: koSystemMonitoringMessages as JsonObject },
  { name: 'systemSearch', messages: koSystemSearchMessages as JsonObject },
  { name: 'systemConfig', messages: koSystemConfigMessages as JsonObject },
];

function isPlainObject(value: unknown): value is JsonObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function cloneJsonValue<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => cloneJsonValue(item)) as T;
  }

  if (isPlainObject(value)) {
    return Object.fromEntries(Object.entries(value).map(([key, nextValue]) => [key, cloneJsonValue(nextValue)])) as T;
  }

  return value;
}

function mergeJsonObject(target: JsonObject, source: JsonObject, sourceName: string, path: string[] = []): void {
  for (const [key, nextValue] of Object.entries(source)) {
    const nextPath = [...path, key];
    const currentValue = target[key];

    if (currentValue === undefined) {
      target[key] = cloneJsonValue(nextValue);
      continue;
    }

    if (isPlainObject(currentValue) && isPlainObject(nextValue)) {
      mergeJsonObject(currentValue, nextValue, sourceName, nextPath);
      continue;
    }

    throw new Error(`Duplicate i18n key detected at "${nextPath.join('.')}" while merging "${sourceName}".`);
  }
}

function overlayJsonObject(target: JsonObject, source: JsonObject): void {
  for (const [key, nextValue] of Object.entries(source)) {
    const currentValue = target[key];

    if (isPlainObject(currentValue) && isPlainObject(nextValue)) {
      overlayJsonObject(currentValue, nextValue);
      continue;
    }

    target[key] = cloneJsonValue(nextValue);
  }
}

export function loadMessages(locale: AppLocale = 'en'): JsonObject {
  const merged: JsonObject = {};

  for (const source of messageSources) {
    mergeJsonObject(merged, source.messages, source.name);
  }

  if (locale === 'ko') {
    for (const source of koOverrideSources) {
      overlayJsonObject(merged, source.messages);
    }
  }

  return merged;
}
